import { useTranslation } from 'react-i18next';
import { Button, Divider, Tag, Select, Tooltip, Affix } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useRef } from 'react';
import { useEffect } from 'react';
import IconEmpty from '../../../../assets/Images/icons/empty';
import DataFlowService from '../../../../services/DataFlow.service';
import ModalDelete from '../../../../components/Shared/modal/delete';
import useNotify from '../../../../context/Notification/useNotify';
import { metaDataRender } from '../../../../util/tagRender';
import { ROUTER } from '../../../../constants/router';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { STATUS_ID as STATUS } from '../../STATUS_ID';

const { Option } = Select;

const Tab2 = ({
    categoryPersonalData,
    editMode,
    metadataList,
    getDataFlowDetail,
    getMetadataList,
    isNoPermission,
    dataFlowInfo
}) => {
    let { businessProcessId } = useParams();
    const navigate = useNavigate();
    const notify = useNotify();
    const { t } = useTranslation();
    const [data, setData] = useState(categoryPersonalData);
    const inputPersonalRef = useRef([]);
    const inputSensitiveRef = useRef([]);
    const [openDelete, setOpenDelete] = useState(false);
    const [deletevalue, setDeleteValue] = useState();
    const [idxPersonal, setIdxPersonal] = useState();
    const [idxSensitive, setIdxSensitive] = useState();

    useEffect(() => {
        if (idxPersonal != null) {
            inputPersonalRef.current[idxPersonal].focus();
        }
    }, [idxPersonal]);

    useEffect(() => {
        if (idxSensitive != null) {
            inputSensitiveRef.current[idxSensitive].focus();
        }
    }, [idxSensitive]);

    useEffect(() => {
        if (categoryPersonalData) {
            setData(categoryPersonalData);
        }
    }, [categoryPersonalData]);

    useEffect(() => {
        if (data?.personalData.length > 0) {
            data.personalData.forEach((element) => {
                validateInputVisible(element);
            });
        }

        if (data?.sensitiveData.length > 0) {
            data.sensitiveData.forEach((element) => {
                validateInputVisible(element);
            });
        }

        if (data?.personalDataTopic.length > 0) {
            data.personalDataTopic.forEach((element) => {
                if (element.personalDataTopicOption.length > 0) {
                    element.personalDataTopicOption.forEach((element) => {
                        validateInputVisible(element);
                    });
                }
            });
        }
    }, [data]);

    const validateInputVisible = (element) => {
        if (element.metadata.length > 0) {
            element.inputVisible = true;
        } else {
            element.inputVisible = false;
        }
    };

    const handleChange = async (e, referenceId) => {
        const lastValue = e[e.length - 1];
        const metadata = await metadataList.find((m) => m.value === lastValue);
        if (lastValue) {
            if (metadata) {
                const payload = {
                    referenceId: referenceId,
                    metadataId: metadata.id,
                };
                updateMappingMetadata(payload);
            } else {
                const payload = {
                    referenceId: referenceId,
                    metadataName: lastValue,
                };
                createMetadata(payload);
            }
        }
    };

    const updateMappingMetadata = async (payload) => {
        await DataFlowService.mappingMetadata(payload)
            .then((res) => {
                getDataFlowDetail();
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const createMetadata = async (payload) => {
        await DataFlowService.createMetadata(payload)
            .then((res) => {
                getDataFlowDetail();
                getMetadataList();
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const onClose = (e, props, referenceId) => {
        e.preventDefault();
        setOpenDelete(true);
        const metadata = metadataList.find(
            (meta) => meta.value === props.value
        );
        if (metadata) {
            setDeleteValue({
                referenceId: referenceId,
                metadataId: metadata.id,
                metadataName: metadata.value,
            });
        }
    };

    const deleteMetadata = async () => {
        await DataFlowService.deleteMetadata(
            deletevalue.referenceId,
            deletevalue.metadataId
        )
            .then((res) => {
                setOpenDelete(false);
                getDataFlowDetail();
                getMetadataList();
                notify({
                    title: t('common.Success'),
                    description: t('Successfully deleted data'),
                });
            })
            .catch((err) => {
                setOpenDelete(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('common.FailedDeleteData'),
                });
            });
    };

    return (
        <div className="grid grid-cols-2">
            <div className="col-span-2 text-right mt-2 mb-2">
                <Affix offsetTop={60}>
                    <Button
                        hidden={!editMode || (isNoPermission && dataFlowInfo.statusId !== STATUS.REVISE)}
                        type="primary"
                        style={{ padding: '0px 30px' }}
                        onClick={() => {
                            navigate(
                                `${ROUTER.DS_INVENTORY.DATAFLOW}/${businessProcessId}?tab=2`
                            );
                        }}
                        size="large"
                        ghost
                    >
                        {t('common.Edit')}
                    </Button>
                </Affix>
            </div>

            {categoryPersonalData && data !== null ? (
                <>
                    <div className="col-span-2 mb-2">
                        <span className="text-xl font-semibold">
                            {t('dataFlow.typeAndDetailData')}
                        </span>
                    </div>
                    {/* start personalData */}
                    {data?.personalData.length > 0 && (
                        <div
                            className="col-span-2 mb-2"
                            style={{ backgroundColor: '#F4F6FC' }}
                        >
                            <div className="grid grid-cols-2 p-4">
                                <div className="col-span-1">
                                    <span className="font-large font-semibold text-gray-600">
                                        {t('dataFlow.personalData')}
                                    </span>
                                </div>
                                <div className="col-span-1 flex">
                                    <span className="font-large font-semibold text-gray-600">
                                        {t('dataFlow.Category')}
                                    </span>
                                    <Tooltip
                                        placement="right"
                                        overlayClassName="min-w-[320px]"
                                        title={
                                            <div className="whitespace-pre-line">
                                                {t('dataFlow.CategoryTooltip')}
                                            </div>
                                        }
                                    >
                                        <a className="bg-purple-light p-2 flex items-center justify-center rounded-lg text-purple ml-2">
                                            <ExclamationCircleOutlined />
                                        </a>
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="col-span-2 mb-2">
                        {data?.personalData.length > 0 &&
                            data.personalData.map((personalData, index) => (
                                <>
                                    <div className="grid grid-cols-2 p-4 flex items-center justify-center">
                                        <div className="col-span-1 mb-2">
                                            <span
                                                className="font-large"
                                                key={index}
                                            >
                                                {personalData.name}
                                            </span>
                                        </div>
                                        <div className="col-span-1">
                                            {personalData.inputVisible ||
                                                personalData.metadata.length > 0 ? (
                                                <Select
                                                    disabled={!editMode}
                                                    size="large"
                                                    mode="tags"
                                                    className="meta"
                                                    ref={(element) =>
                                                    (inputPersonalRef.current[
                                                        index
                                                    ] = element)
                                                    }
                                                    style={{ width: '100%' }}
                                                    filterOption={(
                                                        input,
                                                        option
                                                    ) =>
                                                        option.children
                                                            .toLowerCase()
                                                            .includes(
                                                                input.toLowerCase()
                                                            )
                                                    }
                                                    tagRender={(props) =>
                                                        metaDataRender({
                                                            ...props,
                                                            onClose: (e) =>
                                                                onClose(
                                                                    e,
                                                                    props,
                                                                    personalData.personalDataOptionId
                                                                ),
                                                            closable: editMode,
                                                        })
                                                    }
                                                    value={personalData.metadata?.map(
                                                        (meta) => meta.name
                                                    )}
                                                    onChange={(e) =>
                                                        handleChange(
                                                            e,
                                                            personalData.personalDataOptionId
                                                        )
                                                    }
                                                    onBlur={() => {
                                                        personalData.inputVisible = false;
                                                        setData({ ...data });
                                                        setIdxPersonal(null);
                                                    }}
                                                >
                                                    {metadataList?.map(
                                                        (meta) => (
                                                            <Option
                                                                key={meta.id}
                                                                value={
                                                                    meta.value
                                                                }
                                                            >
                                                                {meta.value}
                                                            </Option>
                                                        )
                                                    )}
                                                </Select>
                                            ) : (
                                                <Tag
                                                    color="processing"
                                                    className="meta-site-tag-plus pt-1 pb-1 pl-3 pr-3 ml-4 cursor-pointer"
                                                    hidden={!editMode || (isNoPermission && dataFlowInfo.statusId !== STATUS.REVISE)}
                                                    onClick={() => {
                                                        personalData.inputVisible = true;
                                                        setData({ ...data });
                                                        setIdxPersonal(index);
                                                    }}
                                                >
                                                    <PlusOutlined />{' '}
                                                    {t('dataFlow.AddMetadata')}
                                                </Tag>
                                            )}
                                        </div>
                                    </div>
                                    <Divider className="m-0" />
                                </>
                            ))}
                    </div>

                    {/* start sensitiveData */}
                    {data?.sensitiveData.length > 0 && (
                        <div
                            className="col-span-2 mb-2"
                            style={{ backgroundColor: '#F4F6FC' }}
                        >
                            <div className="grid grid-cols-2 p-4">
                                <div className="col-span-1">
                                    <span className="font-large font-semibold text-gray-600">
                                        {t('dataFlow.sensitiveData')}
                                    </span>
                                </div>
                                <div className="col-span-1 flex">
                                    <span className="font-large font-semibold text-gray-600">
                                        {t('dataFlow.Category')}
                                    </span>
                                    <Tooltip
                                        placement="right"
                                        overlayClassName="min-w-[320px]"
                                        title={
                                            <div className="whitespace-pre-line">
                                                {t('dataFlow.CategoryTooltip')}
                                            </div>
                                        }
                                    >
                                        <a className="bg-purple-light p-2 flex items-center justify-center rounded-lg text-purple ml-2">
                                            <ExclamationCircleOutlined />
                                        </a>
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="col-span-2 mb-2">
                        {data?.sensitiveData.length > 0 &&
                            data.sensitiveData.map((sensitiveData, index) => (
                                <>
                                    <div className="grid grid-cols-2 p-4 flex items-center justify-center">
                                        <div className="col-span-1 mb-2">
                                            <span
                                                className="font-large"
                                                key={index}
                                            >
                                                {sensitiveData.name}
                                            </span>
                                        </div>
                                        <div className="col-span-1">
                                            {sensitiveData.inputVisible ||
                                                sensitiveData.metadata.length >
                                                0 ? (
                                                <Select
                                                    disabled={!editMode}
                                                    size="large"
                                                    mode="tags"
                                                    className="meta"
                                                    ref={(element) =>
                                                    (inputSensitiveRef.current[
                                                        index
                                                    ] = element)
                                                    }
                                                    style={{ width: '100%' }}
                                                    filterOption={(
                                                        input,
                                                        option
                                                    ) =>
                                                        option.children
                                                            .toLowerCase()
                                                            .includes(
                                                                input.toLowerCase()
                                                            )
                                                    }
                                                    tagRender={(props) =>
                                                        metaDataRender({
                                                            ...props,
                                                            onClose: (e) =>
                                                                onClose(
                                                                    e,
                                                                    props,
                                                                    sensitiveData.sensitivePersonalDataOptionId
                                                                ),
                                                            closable: editMode,
                                                        })
                                                    }
                                                    value={sensitiveData.metadata?.map(
                                                        (meta) => meta.name
                                                    )}
                                                    onChange={(e) =>
                                                        handleChange(
                                                            e,
                                                            sensitiveData.sensitivePersonalDataOptionId
                                                        )
                                                    }
                                                    onBlur={() => {
                                                        sensitiveData.inputVisible = false;
                                                        setData({ ...data });
                                                        setIdxSensitive(null);
                                                    }}
                                                >
                                                    {metadataList?.map(
                                                        (meta) => (
                                                            <Option
                                                                key={meta.id}
                                                                value={
                                                                    meta.value
                                                                }
                                                            >
                                                                {meta.value}
                                                            </Option>
                                                        )
                                                    )}
                                                </Select>
                                            ) : (
                                                <Tag
                                                    color="processing"
                                                    className="meta-site-tag-plus pt-1 pb-1 pl-3 pr-3 ml-4 cursor-pointer"
                                                    hidden={!editMode || (isNoPermission && dataFlowInfo.statusId !== STATUS.REVISE)}
                                                    onClick={() => {
                                                        sensitiveData.inputVisible = true;
                                                        setData({ ...data });
                                                        setIdxSensitive(index);
                                                    }}
                                                >
                                                    <PlusOutlined />{' '}
                                                    {t('dataFlow.AddMetadata')}
                                                </Tag>
                                            )}
                                        </div>
                                    </div>
                                    <Divider className="m-0" />
                                </>
                            ))}
                    </div>

                    {/* start personalDataTopic */}
                    {data?.personalDataTopic.length > 0 &&
                        data.personalDataTopic.map((item, indexTopic) => (
                            <>
                                <div
                                    className="col-span-2 mb-2"
                                    style={{ backgroundColor: '#F4F6FC' }}
                                >
                                    <div className="grid grid-cols-2 p-4">
                                        <div className="col-span-1">
                                            <span
                                                key={indexTopic}
                                                className="font-large font-semibold text-gray-600"
                                            >
                                                {item.personalDataTopicName}
                                            </span>
                                        </div>
                                        <div className="col-span-1 flex">
                                            <span className="font-large font-semibold text-gray-600">
                                                {t('dataFlow.Category')}
                                            </span>
                                            <Tooltip
                                                placement="right"
                                                overlayClassName="min-w-[320px]"
                                                title={
                                                    <div className="whitespace-pre-line">
                                                        {t(
                                                            'dataFlow.CategoryTooltip'
                                                        )}
                                                    </div>
                                                }
                                            >
                                                <a className="bg-purple-light p-2 flex items-center justify-center rounded-lg text-purple ml-2">
                                                    <ExclamationCircleOutlined />
                                                </a>
                                            </Tooltip>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-span-2 mb-2">
                                    {item?.personalDataTopicOption.length > 0 &&
                                        item.personalDataTopicOption.map(
                                            (
                                                personalDataTopicOption,
                                                index
                                            ) => (
                                                <>
                                                    <div className="grid grid-cols-2 p-4 flex items-center justify-center">
                                                        <div className="col-span-1 mb-2">
                                                            <span
                                                                className="font-large"
                                                                key={index}
                                                            >
                                                                {
                                                                    personalDataTopicOption.personalDataTopicOptionName
                                                                }
                                                            </span>
                                                        </div>
                                                        <div className="col-span-1">
                                                            {personalDataTopicOption.inputVisible ||
                                                                personalDataTopicOption
                                                                    .metadata
                                                                    .length > 0 ? (
                                                                <Select
                                                                    disabled={
                                                                        !editMode
                                                                    }
                                                                    size="large"
                                                                    mode="tags"
                                                                    className="meta"
                                                                    style={{
                                                                        width: '100%',
                                                                    }}
                                                                    filterOption={(
                                                                        input,
                                                                        option
                                                                    ) =>
                                                                        option.children
                                                                            .toLowerCase()
                                                                            .includes(
                                                                                input.toLowerCase()
                                                                            )
                                                                    }
                                                                    tagRender={(
                                                                        props
                                                                    ) =>
                                                                        metaDataRender(
                                                                            {
                                                                                ...props,
                                                                                onClose:
                                                                                    (
                                                                                        e
                                                                                    ) =>
                                                                                        onClose(
                                                                                            e,
                                                                                            props,
                                                                                            personalDataTopicOption.personalDataTopicOptionId
                                                                                        ),
                                                                                closable:
                                                                                    editMode,
                                                                            }
                                                                        )
                                                                    }
                                                                    value={personalDataTopicOption.metadata?.map(
                                                                        (
                                                                            meta
                                                                        ) =>
                                                                            meta.name
                                                                    )}
                                                                    onChange={(
                                                                        e
                                                                    ) =>
                                                                        handleChange(
                                                                            e,
                                                                            personalDataTopicOption.personalDataTopicOptionId
                                                                        )
                                                                    }
                                                                    onBlur={() => {
                                                                        personalDataTopicOption.inputVisible = false;
                                                                        setData(
                                                                            {
                                                                                ...data,
                                                                            }
                                                                        );
                                                                    }}
                                                                >
                                                                    {metadataList?.map(
                                                                        (
                                                                            meta
                                                                        ) => (
                                                                            <Option
                                                                                key={
                                                                                    meta.id
                                                                                }
                                                                                value={
                                                                                    meta.value
                                                                                }
                                                                            >
                                                                                {
                                                                                    meta.value
                                                                                }
                                                                            </Option>
                                                                        )
                                                                    )}
                                                                </Select>
                                                            ) : (
                                                                <Tag
                                                                    color="processing"
                                                                    className="meta-site-tag-plus pt-1 pb-1 pl-3 pr-3 ml-4 cursor-pointer"
                                                                    hidden={
                                                                        !editMode || (isNoPermission && dataFlowInfo.statusId !== STATUS.REVISE)
                                                                    }
                                                                    onClick={() => {
                                                                        personalDataTopicOption.inputVisible = true;
                                                                        setData(
                                                                            {
                                                                                ...data,
                                                                            }
                                                                        );
                                                                    }}
                                                                >
                                                                    <PlusOutlined />{' '}
                                                                    {t(
                                                                        'dataFlow.AddMetadata'
                                                                    )}
                                                                </Tag>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <Divider className="m-0" />
                                                </>
                                            )
                                        )}
                                </div>
                            </>
                        ))}
                </>
            ) : (
                <div className="col-span-2 h-[30vh] flex justify-center items-center">
                    <IconEmpty />
                </div>
            )}

            <ModalDelete
                open={openDelete}
                text={t('dataCorrelation.ConfirmedDelete', {
                    name: deletevalue?.metadataName,
                })}
                handelOk={() => {
                    deleteMetadata();
                }}
                handelClose={() => setOpenDelete(false)}
            />
        </div>
    );
};
export default Tab2;
